import { render, staticRenderFns } from "./ModuliEdit.vue?vue&type=template&id=6f4e12c8&scoped=true"
import script from "./ModuliEdit.vue?vue&type=script&lang=js"
export * from "./ModuliEdit.vue?vue&type=script&lang=js"
import style0 from "./ModuliEdit.vue?vue&type=style&index=0&id=6f4e12c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4e12c8",
  null
  
)

export default component.exports